var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h3',{staticClass:"title"},[_vm._v("Wybierz usługę")]),_vm._v(" "),_vm._l((_vm.ServiceTypeList),function(eq,i){return _c('div',{key:i,staticClass:"btn-group"},[_c('button',{staticClass:"btn full",style:({ background: _vm.$color }),attrs:{"type":"button"},on:{"click":function($event){return _vm.btnHandler(eq.k)}}},[_vm._v(_vm._s(eq.v))])])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf76d0da","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/assistance_steps/StepOtherService.vue
// module id = 273
// module chunks = 0